import React from 'react'

import { Typography, colors } from '@material-ui/core'

import { ConfirmationDialog } from 'components'

const AutomationConfirmDialog = ({
  pendingSavePayload,
  setPendingSavePayload,
  onConfirm,
}) => (
  <ConfirmationDialog
    open={Boolean(pendingSavePayload)}
    setOpen={(value) => {
      if (!value) setPendingSavePayload(null)
    }}
    actionAcceptButton={onConfirm}
    textButton="Prosseguir"
    textButtonCancel="Voltar"
    accentColor={colors.pink[900]}
    text={
      <Typography variant="body1">
        Essa é uma atividade automática do sistema, ao movê-la o fluxo original
        será cancelado, tem certeza que deseja mover essa atividade?
      </Typography>
    }
  />
)

export default AutomationConfirmDialog
